const MIN_CHUNK_SIZE = 20 * 1024 * 1024;
const MAX_CHUNK_SIZE = 500 * 1024 * 1024;
const MAX_CHUNKS = 1e4;
const calculateChunkSize = (fileSize) => {
  if (fileSize <= MIN_CHUNK_SIZE) {
    return fileSize;
  }
  const minChunksNeeded = Math.ceil(fileSize / MAX_CHUNK_SIZE);
  if (minChunksNeeded > MAX_CHUNKS) {
    return Math.ceil(fileSize / MAX_CHUNKS);
  }
  const targetChunkSize = Math.ceil(fileSize / MAX_CHUNKS);
  return Math.max(MIN_CHUNK_SIZE, Math.min(MAX_CHUNK_SIZE, targetChunkSize));
};

export { calculateChunkSize };
//# sourceMappingURL=calculateChunkSize.js.map
